class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    document
      .querySelectorAll(".sticky-product-variant li")
      .forEach((stickyVariant) => {
        let val = stickyVariant.getAttribute("data-val").toLowerCase();
        if (val == this.currentVariant.title.toLowerCase()) {
          document
            .querySelectorAll(".sticky-product-variant li")
            .forEach((stickyVariantRmv) => {
              stickyVariantRmv.classList.remove("active");
            });
          stickyVariant.classList.add("active");
        }
      });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if (document.querySelector(".media-thumb")) {
      document
        .querySelectorAll(".media-thumb .media-grid-column")
        .forEach(function (e) {
          var mediaid = e.dataset.id;
          if (mediaid == fetured_id) {
            new Swiper(".media-nav").slideTo(e.dataset.index, 1000, false);
          }
        });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll(".option-wrap"));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function (eachfield) {
      var checked_gender = eachfield.querySelector("input:checked");
      if (checked_gender) {
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if (option_count >= fieldlen) {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      }
    });
    if (option_count >= fieldlen) {
      document.querySelectorAll(".choose-cart").forEach(function (chooseCart) {
        chooseCart.classList.remove("hide-selectore-button");
      });
      document
        .querySelectorAll(".choose-selector")
        .forEach(function (chooseSelector) {
          chooseSelector.classList.add("hide-selectore-button");
        });
    } else {
      document.querySelectorAll(".choose-cart").forEach(function (chooseCart) {
        chooseCart.classList.add("hide-selectore-button");
      });
      document
        .querySelectorAll(".choose-selector")
        .forEach(function (chooseSelector) {
          chooseSelector.classList.remove("hide-selectore-button");
        });
    }
  }
  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const addbtnid = ".choose-cart";
        const probadges = ".product-badge";
        const shippingtext = ".prod-pre-order";

        const html = new DOMParser().parseFromString(responseText, "text/html");

        const destination = document.getElementById(id);
        const addbtndestination = document.querySelector(addbtnid);
        const badgesdestination = document.querySelectorAll(probadges);
        const shippingdestination = document.querySelectorAll(shippingtext);

        const source = html.getElementById(id);
        const addbtn = html.querySelector(addbtnid);
        const addbtnbadges = html.querySelector(probadges);
        const shippingbadges = html.querySelector(shippingtext);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (addbtn && addbtndestination) {
          addbtndestination.innerHTML = addbtn.innerHTML;
        }
        if (addbtnbadges && badgesdestination) {
          badgesdestination.forEach((badge) => {
            badge.innerHTML = addbtnbadges.innerHTML;
          });
        }

        if (shippingbadges && shippingdestination) {
          shippingdestination.forEach((shipping) => {
            console.log("shipping", shipping, "shippingbadges", shippingbadges);
            shipping.innerHTML = shippingbadges.innerHTML;
          });
        }
        addtocart();
        if (this.currentVariant) {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        }
      });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector(
      '[name="add"] > span.p-add-cart-btn'
    );
    if (this.currentVariant != undefined) {
      if (this.currentVariant.available) {
        document
          .querySelectorAll(".choose-cart")
          .forEach(function (chooseCart) {
            chooseCart.classList.remove("variant_sold-out");
          });
      } else {
        document
          .querySelectorAll(".choose-cart")
          .forEach(function (chooseCart) {
            chooseCart.classList.add("variant_sold-out");
          });
      }
    }
    if (!addButton) return;
    // if(disable){
    //   addButton.setAttribute('disabled', 'disabled');
    //   if(text) addButtonText.textContent = text;
    // }else {
    //   addButton.removeAttribute('disabled');
    //   if(addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
    // }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector(
      '[name="add"] > span.p-add-cart-btn'
    );
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    if (addButtonText)
      addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-radios", VariantRadios);
function variant_drodown() {
  if (document.querySelector(".dropdown-wrap")) {
    document.querySelectorAll(".dropdown-wrap").forEach(function (dropdown) {
      dropdown
        .querySelector(".variant-dropdown")
        .addEventListener("click", function (event) {
          event.preventDefault();
          dropdown.classList.toggle("active");
          dropdown
            .querySelectorAll('input[type="radio"]')
            .forEach(function (e) {
              e.addEventListener("change", function (button) {
                dropdown.classList.remove("active");
                dropdown.querySelector(".variant-dropdown").innerHTML =
                  button.path[0].value;
              });
            });
        });
    });
  }
}

if (document.querySelectorAll(".product-addcart")) {
  function addtocart() {
    document.querySelectorAll(".product-addcart").forEach((productAddCart) => {
      productAddCart.addEventListener("click", function (evt) {
        evt.preventDefault();
        productAddCart.classList.add("addingCart");
        if (document.querySelector(".recipient-form-wrapper")) {
          let form = evt.target.closest("form");
          let product = {
            name: document.querySelector(
              '.recipient-row input[name="properties[recipient_name]"]'
            ).value,
            date: document.querySelector(
              '.recipient-row input[name="properties[send_date]"]'
            ).value,
            email: document.querySelector(
              '.recipient-row input[name="properties[recipient_email]"]'
            ).value,
            msg: document.querySelector(
              '.recipient-row textarea[name="properties[Message]"]'
            ).value,
            design: document.querySelector(
              '.gc-design-img input:checked[name="properties[gift_card_design]"]'
            ).value,
          };
          let payload = {
            id: form.querySelector('input[name="id"]').value,
            quantity: 1,
            properties: product,
          };
          setTimeout(function () {
            var xhr = new XMLHttpRequest();
            xhr.open("POST", "/cart/add.js", true);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.onreadystatechange = function () {
              if (xhr.readyState === 4 && xhr.status === 200) {
                let response = JSON.parse(xhr.responseText);
                if (typeof load_cart == "function") {
                  cartNotification(response.id);
                  load_cart();
                } else {
                  window.location.href = "/cart";
                }

                setTimeout(() => {
                  productAddCart.classList.remove("addingCart");
                  document
                    .querySelectorAll(".product-addcart")
                    .forEach(function (prodAddCart) {
                      prodAddCart.classList.add("addedCart");
                    });
                  setTimeout(function (e) {
                    document
                      .querySelectorAll(".product-addcart")
                      .forEach(function (prodAddCart) {
                        prodAddCart.classList.remove("addedCart");
                      });
                  }, 2000);
                }, 1300);
              }
            };
            xhr.send(JSON.stringify(payload));
          }, 1000);
        } else {
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];
          var cartform = document
            .querySelector(".product-addcart")
            .closest("form");
          const formData = new FormData(cartform);
          config.body = formData;
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                document.querySelector(".product-form-error").innerHTML =
                  response.description;
                setTimeout(function (e) {
                  document.querySelector(".product-form-error").innerHTML = "";
                }, 2000);
                return;
              } else {
                if (typeof load_cart == "function") {
                  cartNotification(response.id);
                  load_cart();
                } else {
                  window.location.href = "/cart";
                }
              }
              setTimeout(() => {
                productAddCart.classList.remove("addingCart");
                document
                  .querySelectorAll(".product-addcart")
                  .forEach(function (prodAddCart) {
                    prodAddCart.classList.add("addedCart");
                  });
                setTimeout(function (e) {
                  document
                    .querySelectorAll(".product-addcart")
                    .forEach(function (prodAddCart) {
                      prodAddCart.classList.remove("addedCart");
                    });
                }, 2000);
              }, 1300);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {});
        }
      });
    });
  }
  addtocart();
}
if (document.querySelector(".sticky-add"))
  document.querySelector(".sticky-add").addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelector(".product-addcart").click();
  });
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
document.addEventListener("DOMContentLoaded", function () {
  var splide = new Splide(".media-nav", {
    type: "loop",
    drag: "free",
    pagination: false,
    autoWidth: true,
    perMove: 1,
    autoScroll: {
      speed: 1,
      pauseOnHover: false,
    },
  });
  splide.mount(window.splide.Extensions);
  var isPaused = false;
  var disableHover = false;
  document
    .querySelector(".media-nav")
    .addEventListener("mouseover", function () {
      if (
        !isPaused &&
        !disableHover &&
        !document.querySelector("body").classList.contains("pause_media")
      ) {
        splide.Components.AutoScroll.pause();
        document
          .querySelector(".splide_play_pause")
          .classList.add("active_pause");
        document.querySelector("body").classList.add("pause_media");
      }
    });
  document
    .querySelector(".media-nav")
    .addEventListener("mousemove", function (e) {
      if (isPaused == false) {
        splide.Components.AutoScroll.play();
        document
          .querySelector(".splide_play_pause")
          .classList.remove("active_pause");
        document.querySelector("body").classList.remove("pause_media");
      }
      if (
        !isPaused &&
        !disableHover &&
        !document.querySelector("body").classList.contains("pause_media")
      ) {
        splide.Components.AutoScroll.pause();
        document
          .querySelector(".splide_play_pause")
          .classList.add("active_pause");
        document.querySelector("body").classList.add("pause_media");
      }
    });
  document
    .querySelector(".media-nav")
    .addEventListener("mouseout", function () {
      if (!disableHover) {
        splide.Components.AutoScroll.play();
        document
          .querySelector(".splide_play_pause")
          .classList.remove("active_pause");
        document.querySelector("body").classList.remove("pause_media");
        isPaused = false;
      }
    });
  document
    .querySelector(".splide_play_pause a")
    .addEventListener("click", function (e) {
      e.preventDefault();
      disableHover = true;
      if (isPaused) {
        splide.Components.AutoScroll.pause();
        document
          .querySelector(".splide_play_pause")
          .classList.add("active_pause");
        isPaused = false;
      } else {
        splide.Components.AutoScroll.play();
        document
          .querySelector(".splide_play_pause")
          .classList.remove("active_pause");
        isPaused = true;
      }
      // if(isPaused){
      //   splide.Components.AutoScroll.play();
      //   document.querySelector('.splide_play_pause').classList.remove('active_pause');
      //   isPaused = false;
      // }else{
      //   splide.Components.AutoScroll.pause();
      //   document.querySelector('.splide_play_pause').classList.add('active_pause');
      //   isPaused = true;
      // }
      setTimeout(function () {
        disableHover = false;
      }, 500);
    });
});
// document.addEventListener('DOMContentLoaded', function(){
//   var splide = new Splide('.media-nav', {
//     type: 'loop',
//     drag: 'free',
//     pagination: false,
//     autoWidth: true,
//     perMove: 1,
//     autoScroll: {
//       speed: 1,
//       pauseOnHover: false,
//     }
//   });
//   splide.mount(window.splide.Extensions);
//   var isPaused = false;
//   var disableHover = false;
//   document.querySelector('.media-nav').addEventListener('mouseover', function(){
//     if (!isPaused && !disableHover && !document.querySelector('body').classList.contains('pause_media')) {
//       splide.Components.AutoScroll.pause();
//       document.querySelector('.splide_play_pause').classList.add('active_pause');
//       document.querySelector('body').classList.add('pause_media');
//     }
//   });
//   document.querySelector('.media-nav').addEventListener('mousemove', function(){
//     if (!isPaused && !disableHover && !document.querySelector('body').classList.contains('pause_media')) {
//       splide.Components.AutoScroll.pause();
//       document.querySelector('.splide_play_pause').classList.add('active_pause');
//       document.querySelector('body').classList.add('pause_media');
//     }
//   });
//   document.querySelector('.media-nav').addEventListener('mouseout', function(){
//     if(!disableHover){
//       splide.Components.AutoScroll.play();
//       document.querySelector('.splide_play_pause').classList.remove('active_pause');
//       document.querySelector('body').classList.remove('pause_media');
//       isPaused = false; // Set isPaused to false when autoplay resumes
//     }
//   });
//   document.querySelector('.splide_play_pause a').addEventListener('click', function(e){
//     e.preventDefault();
//     disableHover = true;
//     if(isPaused){
//       splide.Components.AutoScroll.play();
//       document.querySelector('.splide_play_pause').classList.remove('active_pause');
//       isPaused = false;
//     }else{
//       splide.Components.AutoScroll.pause();
//       document.querySelector('.splide_play_pause').classList.add('active_pause');
//       isPaused = true;
//     }

//     setTimeout(function(){
//       disableHover = false;
//     }, 500);
//   });
// });
variant_drodown();
document.addEventListener("shopify:section:load", function (event) {
  variant_drodown();
});
// if(document.querySelector('.choose-selector')){
//   if (window.innerWidth < 641) {
//     document.querySelector('.sticky-product-atc .choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
//   }
// }
document.querySelectorAll(".prod-tab-head li").forEach((tabTitle) => {
  tabTitle.addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelectorAll(".prod-tab-head li").forEach((tabTitle) => {
      tabTitle.classList.remove("active-title");
    });
    tabTitle.classList.add("active-title");
    let val = tabTitle.getAttribute("data-val");
    document.querySelectorAll(".prod-tab-cont li").forEach((tabContent) => {
      let allVal = tabContent.getAttribute("data-val");
      if (val == allVal) {
        document.querySelectorAll(".prod-tab-cont li").forEach((tabContent) => {
          tabContent.classList.remove("active-cont");
        });
        tabContent.classList.add("active-cont");
      }
    });
  });
});
if (document.querySelectorAll(".cl-prod-variant")) {
  document.querySelectorAll(".cl-prod-variant").forEach((clProdVariant) => {
    clProdVariant.addEventListener("click", function (e) {
      e.preventDefault();
      let clProdsOpen = clProdVariant
        .closest(".cl-prod-drodown")
        .querySelectorAll("ul li.active");
      clProdsOpen.forEach((clProdOpen) => {
        clProdOpen.classList.remove("active");
      });
      clProdVariant.closest("li").classList.add("active");
      clProdVariant
        .closest(".cl-prod-btm")
        .querySelector(".cl-prod-cart-button")
        .setAttribute("data-id", clProdVariant.getAttribute("data-id"));

      let pretext = clProdVariant.closest("li").getAttribute("data-var");
      let pretextcontent = clProdVariant
        .closest("li")
        .getAttribute("data-text");
      console.log("pretext", pretext);
      if (pretext == "preordervar") {
        clProdVariant
          .closest(".cl-prod-btm")
          .querySelector(".p-add-cart-btn").innerHTML = pretextcontent;
        clProdVariant
          .closest(".cl-prod-btm")
          .querySelector(".cl-prod-cart-button")
          .classList.add("button-pink");
      } else {
        clProdVariant
          .closest(".cl-prod-btm")
          .querySelector(".p-add-cart-btn").innerHTML = pretextcontent;
        clProdVariant
          .closest(".cl-prod-btm")
          .querySelector(".cl-prod-cart-button")
          .classList.remove("button-pink");
      }

      clProdVariant
        .closest(".cl-prod-btm")
        .querySelector(".cl-prod-select-size").style.display = "none";
      clProdVariant
        .closest(".cl-prod-btm")
        .querySelector(".cl-prod-cart-button").style.display = "block";
    });
  });
}
if (document.querySelectorAll(".cl-prod-cart-button")) {
  document.querySelectorAll(".cl-prod-cart-button").forEach((clProd) => {
    clProd.addEventListener("click", function (e) {
      e.preventDefault();
      clProd.classList.add("addingCart");
      let variant_id = clProd.getAttribute("data-id");
      let added = clProd.querySelector(".cl-prod-added-text");
      let add = clProd.querySelector(".cl-prod-add-text");
      let data = {
        items: [
          {
            id: variant_id,
            quantity: 1,
          },
        ],
      };
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((response) => {
          cartNotification(response.items[0].id);
          if (typeof load_cart == "function") {
            load_cart();
          } else {
            window.location.href = "/cart";
          }
          setTimeout(() => {
            clProd.classList.remove("addingCart");
            clProd.classList.add("addedCart");
            setTimeout(function (e) {
              clProd.classList.remove("addedCart");
            }, 2000);
          }, 1300);
        })
        .catch((e) => {
          console.error(e);
        });
    });
  });
}
if (document.querySelector('.prod-tab-cont li[data-val="fit"] p a'))
  document
    .querySelector('.prod-tab-cont li[data-val="fit"] p a')
    .addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector("body").classList.add("open-size");
    });
if (document.querySelector(".sg-close"))
  document.querySelector(".sg-close").addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelector("body").classList.remove("open-size");
  });
document.addEventListener("DOMContentLoaded", function () {
  const overlayBox = document.querySelector(".overlay-box");
  if (overlayBox) {
    overlayBox.addEventListener("click", function () {
      document.querySelector("body").classList.remove("open-size");
    });
  }
});
function getElementY(query) {
  return (
    window.pageYOffset +
    document.querySelector(query).getBoundingClientRect().top
  );
}
function doScrolling(element, duration) {
  var startingY = window.pageYOffset;
  var elementY = getElementY(element);
  var targetY =
    document.body.scrollHeight - elementY < window.innerHeight
      ? document.body.scrollHeight - window.innerHeight
      : elementY;
  var diff = targetY - startingY;
  var easing = function (t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  };
  var start;
  if (!diff) return;
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    var time = timestamp - start;
    var percent = Math.min(time / duration, 1);
    percent = easing(percent);
    window.scrollTo(0, startingY + diff * percent);
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
}
function checkStickyBar() {
  if (
    document.querySelector("#product-form-installment") &&
    document.querySelector("#product-form-installment").getBoundingClientRect()
      .height +
      document.querySelector(".snippet-addto-cart").offsetHeight +
      document
        .querySelector("#product-form-installment")
        .getBoundingClientRect().top -
      window.innerHeight <
      0
  ) {
    document.querySelector("body").classList.remove("stickybar");
  } else {
    document.querySelector("body").classList.add("stickybar");
  }
}
window.addEventListener("scroll", checkStickyBar);
window.addEventListener("load", checkStickyBar);
// function checkStickyBar(){
//   var chooseCart = document.querySelector('#product-form-installment');
//   var stickyCart = document.querySelector('.sticky-product-cart');
//   if(chooseCart && stickyCart){
//     if(isInViewport(chooseCart, 0)){
//       document.querySelector('body').classList.remove('stickybar');
//     } else {
//       document.querySelector('body').classList.add('stickybar');
//     }
//   }
// }
// window.addEventListener('scroll', checkStickyBar);
// window.addEventListener('load', checkStickyBar);
// function isInViewport(element, offset){
//   var rect = element.getBoundingClientRect();
//   return (
//     rect.top >= 0 &&
//     rect.left >= 0 &&
//     rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + offset &&
//     rect.right <= (window.innerWidth || document.documentElement.clientWidth)
//   );
// }
document.addEventListener("DOMContentLoaded", function () {
  var maxElements = document.querySelectorAll(".b2b_qty[max]");
  let total = 0;
  maxElements.forEach(function (element) {
    element.addEventListener("keyup", function (event) {
      if (
        (event.key >= "0" && event.key <= "9") ||
        event.key === "Backspace" ||
        event.key === "Delete"
      ) {
        element.classList.add("active");
        var max = parseInt(element.getAttribute("max"), 10);
        var value = parseInt(element.value, 10) || 0;
        if (value > max) {
          element.value = max;
          value = max;
        }
        total = 0;
        maxElements.forEach(function (el) {
          total += parseInt(el.value, 10) || 0;
        });
        let limit = parseInt(
          document.querySelector(".variant-row-list").getAttribute("data-min"),
          10
        );
        if (total >= limit) {
          document.querySelector(".b2b-btns").classList.add("activeAddBtn");
        } else {
          document.querySelector(".b2b-btns").classList.remove("activeAddBtn");
        }
      }
    });
  });
});
if (document.querySelector(".b2b-addcart"))
  document
    .querySelector(".b2b-addcart")
    .addEventListener("click", function (evt) {
      evt.preventDefault();
      document.querySelector(".b2b-addcart").classList.add("addingCart");
      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      var cartform = document.querySelector(".b2b-addcart").closest("form");
      const formData = new FormData(cartform);
      config.body = formData;
      fetch("/cart", config)
        .then((response) => response.json())
        .then((response) => {
          if (typeof load_cart == "function") {
            load_cart();
            setTimeout(() => {
              document
                .querySelector(".b2b-addcart")
                .classList.remove("addingCart");
              document.querySelector(".b2b-addcart").classList.add("addedCart");
              setTimeout(function (e) {
                document.querySelector("body").classList.add("open-drawer");
              }, 500);
              setTimeout(function (e) {
                document
                  .querySelector(".b2b-addcart")
                  .classList.remove("addedCart");
              }, 2000);
            }, 1300);
          } else {
            window.location.href = "/cart";
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {});
    });
if (document.querySelectorAll(".sticky-product-variant li")) {
  document
    .querySelectorAll(".sticky-product-variant li")
    .forEach((stickyVariant) => {
      stickyVariant.addEventListener("click", function (e) {
        e.preventDefault();
        document
          .querySelectorAll(".sticky-product-variant li")
          .forEach((stickyVariantRmv) => {
            stickyVariantRmv.classList.remove("active");
          });
        stickyVariant.classList.add("active");
        let val = stickyVariant.getAttribute("data-val").toLowerCase();
        document
          .querySelectorAll(".variant-row-list input")
          .forEach((variantVal) => {
            let allVal = variantVal.value.toLowerCase();
            if (allVal == val) {
              variantVal.click();
            }
          });
      });
    });
}
if (document.querySelectorAll(".gc-design-img input"))
  document.querySelectorAll(".gc-design-img input").forEach((radio) => {
    radio.addEventListener("change", function () {
      let newSrc = this.value;
      document.querySelectorAll(".media-grid-column img").forEach((image) => {
        image.setAttribute("data-src", newSrc);
        image.setAttribute("src", newSrc);
      });
    });
  });


document.querySelectorAll('.b2b_qty').forEach((input) => {
  input.addEventListener('focus', function() {
    if (this.value === '0') {
      this.value = '';
    }
  });

  input.addEventListener('blur', function() {
    if (this.value === '') {
      this.value = '0';
    }
  });
});
